var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "39px",
    height: "48px",
    viewBox: "0 0 39 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "lock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-783.000000, -1451.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(765.000000, 1439.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lock",
    transform: "translate(18.866554, 14.115484)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-73",
    stroke: "#004AD1",
    strokeWidth: 0.99,
    fill: "#004AD1",
    points: "36.6787009 16.2870968 0 16.2870968 0 44.5180645 36.6787009 44.5180645"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47271192,10.6167742 C6.47271192,4.75341935 11.7857296,0 18.3393505,0 C24.8929713,0 30.205989,4.75341935 30.205989,10.6167742 L30.205989,17.3729032 L6.47271192,17.3729032 L6.47271192,10.6167742 L6.47271192,10.6167742 Z",
    id: "Stroke-75",
    stroke: "#004AD1",
    strokeWidth: 2.97
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4181358,28.2309677 C19.4181358,28.8314187 18.9359187,29.3167742 18.3393505,29.3167742 C17.743861,29.3167742 17.2605651,28.8314187 17.2605651,28.2309677 C17.2605651,27.6305168 17.743861,27.1451613 18.3393505,27.1451613 C18.9359187,27.1451613 19.4181358,27.6305168 19.4181358,28.2309677 L19.4181358,28.2309677 Z",
    id: "Stroke-69",
    stroke: "#FFFFFF",
    strokeWidth: 1.98
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4181358,29.3167742 L19.4181358,35.8316129",
    id: "Stroke-71",
    stroke: "#FFFFFF",
    strokeWidth: 1.98,
    strokeLinecap: "round"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.bdee6763e273163e4b19cba0eeca4904.svg";
export { ForwardRef as ReactComponent };